import * as React from 'react';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { Button } from 'primereact/button';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import { Avatar } from 'primereact/avatar';
import { v4 as uuid } from 'uuid';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Grid } from '@mui/material';
import { InputText } from 'primereact/inputtext';
import { AlternateEmailOutlined } from '@mui/icons-material';
import SignatureCanvas from "react-signature-canvas";

export default function SiteInductionAttendanceDetails(modalProps: any) {

  const record = modalProps?.record;


  const [fullName, setFullName] = React.useState(record?.full_name || "");
  const [mobile, setMobile] = React.useState(record?.mobile || "");
  const [email, setEmail] = React.useState(record?.email || "");
  const [type, setType] = React.useState(record?.type || "Visitor");
  const [reasonForVisit, setReasonForVisit] = React.useState(record?.reason_for_visit || "");
  const [startAt, setStartAt] = React.useState<any>(record?.start_at ? new Date(record?.start_at) : new Date());
  const [endAt, setEndAt] = React.useState<any>(record?.end_at ? new Date(record?.end_at) : '');
  const [signature, setSignature] = React.useState(record?.signature || "");
  const [idNumber, setIdNumber] = React.useState(record?.id_number || "");

  const signatureRef = React.useRef<any>();

  // Function to clear the signature
  const clearSignature = () => {
    signatureRef.current.clear();
    setSignature('');
  };


  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormControl
            sx={{ display: { sm: 'flex-column', md: 'flex-row' } }}
          >
            <FormLabel style={{ marginBottom: 10 }}>Full Name</FormLabel>
            <InputText value={fullName} onChange={(e) => setFullName(e.target.value)} disabled={type == 'Employee'} type="text" className="p-inputtext-sm PrimeSmallInput" placeholder="Please enter name" readOnly />
          </FormControl>
        </Grid>

        <Grid item xs={6}>
          <FormControl
            sx={{ display: { sm: 'flex-column', md: 'flex-row' } }}
          >
            <FormLabel style={{ marginBottom: 10 }}>ID Number</FormLabel>
            <InputText value={idNumber} onChange={(e) => setIdNumber(e.target.value)} disabled={type == 'Employee'} type="text" className="p-inputtext-sm PrimeSmallInput" placeholder="Please enter ID number" readOnly />
          </FormControl>
        </Grid>

        <Grid item xs={6}>
          <FormControl
            sx={{ display: { sm: 'flex-column', md: 'flex-row' } }}
          >
            <FormLabel style={{ marginBottom: 10 }}>Mobile</FormLabel>
            <PhoneInput
              defaultCountry="za"
              value={mobile}
              disabled={true}
              onChange={e => setMobile(e)}
              inputStyle={{ width: '100%' }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl
            sx={{ display: { sm: 'flex-column', md: 'flex-row' } }}
          >
            <FormLabel style={{ marginBottom: 10 }}>Email</FormLabel>
            <div className="p-inputgroup ">
              <span className="p-inputgroup-addon PrimeSmallInput">
                <AlternateEmailOutlined />
              </span>
              <InputText style={{ width: '100%' }} disabled={type == 'Employee'} value={email} onChange={(e) => setEmail(e.target.value)} type="text" className="p-inputtext-sm PrimeSmallInput" placeholder="Please email" readOnly />
            </div>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl>
            <FormLabel>Viewed On</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <Calendar value={startAt} onChange={(e) => setStartAt(e.value)} showIcon showTime disabled/>
            </FormControl>
          </FormControl>
        </Grid>
        <br />
        <Grid item xs={6}>
          <FormControl>
            <FormLabel>Reason For Visit</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <InputText value={reasonForVisit} placeholder="Reason For Visit" onChange={e => setReasonForVisit(e.target.value)} readOnly />
            </FormControl>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl>
            <FormLabel>Signature</FormLabel>
            {signature != '' ? (
              <div>
                <img src={signature} alt="signature" />
              </div>
            ) : <SignatureCanvas
              ref={signatureRef}
            />}
          </FormControl>
        </Grid>
      </Grid>
      <br /><br />
    </React.Fragment>
  );
}